/**
 * Created by bootdo.
 * 角色相关api
 */
import * as API from './'
import $const from '../common/constant'

export default {

  //查询获取role列表(通过page分页)
  findList: params => {
    return API.POST($const.apiServer.Admin+'/role/pageList', params)
  },
  //查询成员角色
  findMemberList: params => {
    return API.GET($const.apiServer.Admin+'/role/member-list', params);
  },
  //查询获取一条role信息
  findById: id => {
    return API.GET($const.apiServer.Admin+'/role/userId/'+id)
  },

  add: params => {
    return API.POST($const.apiServer.Admin+'/role/save', params) //`/api-admin/role`
  },
  update: (id, params) => {
    return API.POST($const.apiServer.Admin+'/role/update', params)
  },

  //单个删除role
  remove: id => {
    return API.GET($const.apiServer.Admin+'/role/remove',{id:id})
  },

  //批量删除，传ids数组
  removeBatch: (ids) => {
    return API.DELETE(`/api/v1/roles/batch/${ids}`)
  },
  //是否显示课件-查询
  getByParamKey: params => {
    return API.GET($const.apiServer.Admin+'/config/getByParamKey',params)
  },

  //是否显示课件-设置
  setByParamKey: params => {
    return API.PUT($const.apiServer.Admin+'/config',params)
  },
}



// WEBPACK FOOTER //
// ./src/api/api_role.js